module.exports = __webpack_public_path__ + "static/android-icon-192x192-ad8aa1f3f10928f2c68a0b972ddc82a8.png";